export const LOCAL_STORAGE = {
  // change BOILER_PLATE_ into app name
  BOILER_PLATE_LANGUAGE: 'BOILER_PLATE_LANGUAGE',
  OAUTH_ACCESS_TOKEN: 'OAUTH_ACCESS_TOKEN',
  USER_AUTH: 'USER_AUTH',
  SESSION_EXPIRY: 'SESSION_EXPIRY',
}